import { render, staticRenderFns } from "./tanChuang.vue?vue&type=template&id=480070bf&scoped=true"
import script from "./tanChuang.vue?vue&type=script&lang=js"
export * from "./tanChuang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480070bf",
  null
  
)

export default component.exports